import { alpha, Chip, ChipProps, useTheme } from '@mui/material';
import type { Theme } from '@mui/material/styles';

import { ModuleStatus } from 'pages/cadastro/permissoes/types';

const getColors = (theme: Theme) => ({
    none: {
        border: alpha(theme.palette.grey[500], 0.5),
        bg: alpha(theme.palette.grey[500], 0.1),
        text: theme.palette.grey[500],
    },
    all: {
        border: 'success.light',
        bg: alpha(theme.palette.success.light, 0.1),
        text: 'success.main',
    },
    partial: {
        border: 'warning.light',
        bg: alpha(theme.palette.warning.light, 0.1),
        text: 'warning.main',
    },
});

export type PermissoesModulosChip = Omit<ChipProps, 'color'> & {
    status: ModuleStatus;
};

export function PermissoesModulosChip({ status, sx, ...props }: PermissoesModulosChip) {
    const theme = useTheme();
    const colors = getColors(theme);

    return (
        <Chip
            size="small"
            sx={{
                height: 22,
                minWidth: 28,
                fontSize: 11,
                fontWeight: 700,
                border: 1,
                borderColor: colors[status].border,
                bgcolor: colors[status].bg,
                color: colors[status].text,
                ...sx,
            }}
            {...props}
        />
    );
}
